import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { getEnv } from '@unni/platform'

import CommitIdPlugin from './CommitIdPlugin'
import BrowserPlugin from './BrowserPlugin'

import { AuthTokenTracker } from '../../features/oauth/utils/auth-token-tracker'
import { isBrowser } from '../common'

import { detectSearchEngineCrawler } from '@/shared/utils/crawler-detection'

// Node.js 환경에서 사용하는 Amplitude SDK가 별도로 존재합니다.
const initializeAmplitude = () => {
  if (!isBrowser()) {
    return
  }
  // 크롤러 감지 - 크롤러인 경우 Amplitude 초기화하지 않음
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  if (detectSearchEngineCrawler(userAgent)) {
    console.log('[amplitude] Crawler detected, skipping Amplitude initialization')
    return
  }
  // Amplitude Session Replay 활성화를 위한 Add-on 입니다.
  const sessionReplayTracking = sessionReplayPlugin({
    forceSessionTracking: false,
    sampleRate: getEnv('NEXT_PUBLIC_ENV') === 'local' ? 1 : 0,
  })

  amplitude.add(new CommitIdPlugin())
  amplitude.add(new BrowserPlugin())
  amplitude.add(sessionReplayTracking)

  // Amplitude를 initialize 합니다.
  const url = new URL(window.location.href)
  const ampDeviceId = url.searchParams.get('ampDeviceId')
  const amplitudeKey = getEnv<string>('NEXT_PUBLIC_AMPLITUDE_KEY') || ''
  if (amplitudeKey) {
    amplitude.init(amplitudeKey, {
      defaultTracking: true,
      deviceId: ampDeviceId || undefined,
    })

    // Amplitude 초기화 직후 hashedToken User Property 설정
    AuthTokenTracker.setAmplitudeHashedToken(amplitude)
  }
  // console.log('[amplitude initialized]')
}

initializeAmplitude()

export const amplitudeTracker = amplitude
